import React, { useState } from 'react';
import { GoogleButton } from '../../assets/svgs/svgs';
import { RefreshCw } from 'lucide-react';

const ReconnectModal = ({ onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleConnect = async () => {
    setIsLoading(true);
    await onContinue();
    setIsLoading(false);
  };

  // Modal cannot be closed - user must reconnect Google account
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md" />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-visible">
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
          <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center">
              <RefreshCw className="w-6 h-6 text-[#78350F]" />
            </div>
          </div>
        </div>
        <div className="px-8 pt-12 pb-6 text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Reconnect Your Account
          </h2>
          <p className="text-base text-[#57534E] mb-5 leading-relaxed">
            Your Google account has been disconnected. Please reconnect to continue using all features.
          </p>
          <button
            onClick={handleGoogleConnect}
            disabled={isLoading}
            className="w-full bg-[#6B4423] text-white font-medium py-3 px-6 rounded-lg flex items-center justify-center gap-2 hover:bg-[#5a3a1e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <GoogleButton />
            {isLoading ? 'Connecting...' : 'Reconnect With Google'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReconnectModal;
